import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";
import { shortenedName } from "@ponder-shared/utils/general";
import { MagicMarkdownService } from "../markdown/magic-markdown.service";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { MagicDeckCardDialogComponent } from "./magic-deck-card-dialog.component";
import { DeckRowComponent } from "@ponder-features/user/decks/deck/deck-row.component";
import { getMagicCardRoute } from "../card/magicCardRouter";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";
import { NgClass } from "@angular/common";

@Component({
    selector: "magic-deck-row",
    imports: [MagicDeckCardDialogComponent, NgClass],
    templateUrl: "./magic-deck-row.component.html"
})
export class MagicDeckRowComponent extends DeckRowComponent implements AfterViewInit {
    @ViewChild("manaValue") private manaValueRef!: ElementRef<HTMLElement>;

    public readonly editSvgIcon: string = SvgIconMap.get(SvgIcon.EditMinimal)!;
    public readonly closeSvgIcon: string = SvgIconMap.get(SvgIcon.Close)!;

    public displayRowEdit: boolean = false;

    public constructor(elementRef: ElementRef, private magicMarkdown: MagicMarkdownService) {
        super(elementRef);
    }

    public ngAfterViewInit(): void {
        this.manaValueRef.nativeElement.innerHTML = this.magicMarkdown.formatText(this.manaValueRef.nativeElement.innerHTML, true);    
    }

    public getUrl(): string {
        return getMagicCardRoute(this.deckCard.card.item.data!.magic!);
    }

    public getShortenedName(name: string): string {
        return shortenedName(name, 32);
    }

    public getCardName(): string {
        return this.getShortenedName(this.deckCard.card.item.data!.magic!.faces![0].name!);
    }
    
    public getManaValue(): string {
        return this.deckCard.card.item.data?.magic?.faces![0].manaCost ?? "";
    }
    
    public onCardHover(): void {
        
    }

    public getCollectedCount(): string {
        var count = 
                Math.min(this.deckCard.count, (this.deckCard.card.collected?.count ?? 0)) +
                Math.min(this.deckCard.specialCount, (this.deckCard.card.collected?.specialCount ?? 0));

        return (count > 0 ? `${count} /` : "");
    }

    public onCardCountInput(input: HTMLInputElement): void {
        var value = Number.parseInt(input.value);

        if (isNaN(value) || (value < 0) || (value > 99) || (value == this.deckCard.count)) {
            input.value = `${this.deckCard.count}`;
            return;
        }

        this.deckComponent.adjustCardCount(this.deckCard, (value - this.deckCard.count), 0, () => {
            input.value = `${this.deckCard.count}`;
        });
    }

    public onEditClicked(event: Event): void {
        if (!this.displayRowEdit) {
            this.displayRowEdit = true;
        }
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }
}